import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { EToastItemType } from 'projects/shared/lib/enum/toast/toast-entry-type.enum';
import { ICookieInformationDialogService, ICookieInformationDialogServiceToken } from 'shared/services/ui/dialogs/cookie-information/cookie-information-dialog-service.abstract';
import { IAuthService, IAuthServiceToken } from 'projects/shared/lib/services/infrastructure/authentication/auth-service.interface';
import { Subscription } from 'rxjs';
import { ToastItem } from '../../../toast/item/toast-item.model';
import { ErrorCodeService } from 'projects/shared/lib/services/infrastructure/error-code.service';
import { EError } from 'projects/shared/lib/services/INTEGRA_Shop_Client';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { ICookieBannerService, ICookieBannerServiceToken } from 'shared/services/ui/cookie-banner/cookie-banner-service.interface';
import { IToastService, IToastServiceToken } from 'shared/services/ui/toast/toast-service.interface';

@Component({
  selector: 'app-cookie-banner',
  imports: [],
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss']
})
export class CookieBannerComponent implements OnInit, OnDestroy {
  private cookieTermsAcceptanceStateSubscription: Subscription | undefined;
  private cookieBannerVisibilitySubscription: Subscription | undefined;

  private cookieTermsAcceptanceState: boolean;
  private isCookieBannerDesired: boolean;
  public shouldDisplayCookieBanner: boolean;

  private authService: IAuthService;
  private readonly cookieBannerService: ICookieBannerService = inject(ICookieBannerServiceToken);
  private readonly toastService: IToastService = inject(IToastServiceToken);
  private cookieInformationDialogService: ICookieInformationDialogService;

  public constructor() {
    this.authService = inject(IAuthServiceToken);
    this.cookieInformationDialogService = inject(ICookieInformationDialogServiceToken);

    this.cookieTermsAcceptanceState = false;
    this.isCookieBannerDesired = false;
    this.shouldDisplayCookieBanner = false;
  }

  public ngOnInit(): void {
    if (!this.cookieTermsAcceptanceStateSubscription) {
      this.cookieTermsAcceptanceStateSubscription = this.authService.cookieTermsAcceptanceStateGet().subscribe(
        (cookieTermsAcceptanceState) => {
          this.cookieTermsAcceptanceState = cookieTermsAcceptanceState;
          this.shouldDisplayCookieBannerReevaluate();
        }
      );
    }

    if (!this.cookieBannerVisibilitySubscription) {
      this.cookieBannerVisibilitySubscription = this.cookieBannerService.cookieBannerVisibilityChangedGet().subscribe(
        (cookieBannerDesiredVisibility) => {
          this.isCookieBannerDesired = cookieBannerDesiredVisibility;
          this.shouldDisplayCookieBannerReevaluate();
        }
      );
    }
  }

  public ngOnDestroy(): void {
    this.cookieTermsAcceptanceStateSubscription?.unsubscribe();
    this.cookieBannerVisibilitySubscription?.unsubscribe();
  }

  private shouldDisplayCookieBannerReevaluate() {
    let configHideCookieBanner = ENVIRONMENT.auth.hideCookieBanner;
    let configLoginRequiresCookieAcceptance = ENVIRONMENT.auth.loginRequiresCookiesAcceptance;

    if (this.isCookieBannerDesired != true) {
      this.shouldDisplayCookieBanner = false;
      return;
    }

    if (this.cookieTermsAcceptanceState == true) {
      this.shouldDisplayCookieBanner = false;
      return;
    }

    if (configLoginRequiresCookieAcceptance == true) {
      this.shouldDisplayCookieBanner = true;
      return;
    }

    if (configHideCookieBanner == true) {
      this.shouldDisplayCookieBanner = false;
    } else {
      this.shouldDisplayCookieBanner = true;
    }
  }

  public cookieTermConsentClicked() {
    let cookieTermsAcceptanceState = this.authService.cookieTermsAcceptanceStateSet('yes');
    if (cookieTermsAcceptanceState == true) {
      this.cookieBannerService.cookieBannerHide();
    } else {
      this.toastService.toastItemAdd(new ToastItem({
        type: EToastItemType.Danger,
        message: $localize`:@@CookieBannerConsentSetFailureMessage:Your consent could not be stored. Please refresh and try again.`,
        code: ErrorCodeService.formatErrorCode(EError.F200010)
      }));
    }
  }

  public additionalInformationAndSettingsClicked() {
    this.cookieInformationDialogService.cookieInformationDialogShow(
      () => this.cookieTermConsentClicked(),
    );
  }

}
